import { Component, OnInit, Inject } from '@angular/core';
import {Router} from "@angular/router"
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpErrorResponse} from '@angular/common/http';
import { MatDialog} from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { DlgTrabajandoComponent } from '../../components/dlg-trabajando/dlg-trabajando.component';
import { DlgErrorComponent } from '../../components/dlg-error/dlg-error.component';
import {MatDialogRef} from '@angular/material/dialog';
import { DlgAvisoComponent } from '../../components/dlg-aviso/dlg-aviso.component';
import { DlgBusquedasComponent } from '../../components/dlg-busquedas/dlg-busquedas.component';

@Component({
  selector: 'app-dlg-telefonos',
  templateUrl: './dlg-telefonos.component.html',
  styleUrls: ['./dlg-telefonos.component.css']
})
export class DlgTelefonosComponent implements OnInit {

  titulo="";
  txtTipoTelefono="";
  idTipoTelefono="";
  nombreTipoTelefono="";
  idTelefono="";
  txtTelefono="";

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private httpClient: HttpClient,
    @Inject(SESSION_STORAGE) private storage: StorageService,
    public thisDialogRef: MatDialogRef<DlgTelefonosComponent>,
  ) { }

  ngOnInit(): void {
  }

  cerrarDialogo(dialogoActual) {
    dialogoActual.close();
  }

  cerrar(cadena) {
    this.thisDialogRef.close({mensaje: cadena, idTelefono: this.idTelefono
      ,idTipoTelefono: this.idTipoTelefono
      ,nombreTipoTelefono: this.nombreTipoTelefono
      ,txtTelefono: this.txtTelefono
    });
  }

  buscarTipoTelefono(){
    let dlgBusquedas = this.dialog.open(DlgBusquedasComponent, {
      width: window.innerWidth.toString()+"px",
      disableClose:true
    });
    dlgBusquedas.componentInstance.lblTitBusqueda="Tipo de teléfono:";
    dlgBusquedas.componentInstance.codBusqueda="TIPOTELEFONO";
    dlgBusquedas.componentInstance.txtBusc=this.txtTipoTelefono;
    dlgBusquedas.afterClosed().subscribe(
      data => {
        if (data.idTipoTelefono!=null){
          this.idTipoTelefono=data.idTipoTelefono;
          this.nombreTipoTelefono=data.nombre;
        }
      }
    );
  }

  eliminarTipoTelefono(){
    this.idTipoTelefono="";
    this.nombreTipoTelefono="";
  }

  almacenar(){
    if (this.nombreTipoTelefono==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el teléfono";
      dlgError.componentInstance.texto="Le falto indicar el tipo de teléfono";
      return;
    }
    if (this.txtTelefono==""){
      let dlgError = this.dialog.open(DlgErrorComponent, {
        width: '600px',
        disableClose:true
      });
      dlgError.componentInstance.titulo="Error al almacenar el teléfono";
      dlgError.componentInstance.texto="Le falto indicar el teléfono";
      return;
    }
    this.cerrar('almaceno');
  }
}
